import type { Extensions } from "@tiptap/core"
import StarterKit from "@tiptap/starter-kit"

/** Notes schema: bold, italic, link, lists, and hard breaks. Shared by the editor and HTML rendering. */
export function richTextExtensions(): Extensions {
  return [
    StarterKit.configure({
      blockquote: false,
      code: false,
      codeBlock: false,
      heading: false,
      horizontalRule: false,
      strike: false,
      underline: false,
      trailingNode: false,
      link: {
        openOnClick: false,
        autolink: true,
        defaultProtocol: "https",
      },
    }),
  ]
}
